export const promiseWithRetry = async <T>(
  promiseFn: () => Promise<T>,
  onRetriesExhausted?: (error: unknown) => void,
  maxRetries: number = 3,
  retryDelay: number = 1000,
  currentRetry: number = 0,
): Promise<T> => {
  try {
    return await promiseFn();
  } catch (error) {
    if (currentRetry < maxRetries) {
      await new Promise((resolve) => setTimeout(resolve, retryDelay));
      return promiseWithRetry(
        promiseFn,
        onRetriesExhausted,
        maxRetries,
        retryDelay,
        currentRetry + 1,
      );
    } else {
      if (onRetriesExhausted) {
        onRetriesExhausted(error);
      }
      throw error;
    }
  }
};
